import { AllFieldValueTypes, FieldData } from '90.quickConnect.Models/models';

export const isFieldData = (input: any): boolean =>
  typeof input === 'object' && 'id' in input && 'label' in input && 'fieldType' in input && 'value' in input;

export const isFieldDataArrayforFieldData = (value: AllFieldValueTypes | FieldData[]): value is FieldData[] =>
  Array.isArray(value) && (value as any[]).every(isFieldData);
